// /logs → /workspace-analytics/logs redirect. Logs are workspace telemetry
// analytics family; this tiny page keeps the old URL alive so any
// bookmark, navbar memory, or in-app link landing on /logs still
// reaches the same content under the new path.

export const logsRedirect = {
  tag: 'main',
  id: 'main-content',
  extends: 'AppPage',
  metadata: (el) => ({ title: el.call('pageTitle', 'workspace.redirect.page.title') }),

  AppSidebar: null,

  AppMain: {
    flow: 'y',
    align: 'center center',
    padding: 'C',
    onCreate: (el) => {
      if (typeof window === 'undefined') return
      // Swap to the new path with `replaceState` so the back-button
      // doesn't trap the user on the redirect — same convention
      // bootShell uses for fallbackRoute rewrites.
      try {
        const search = window.location.search || ''
        const target = '/workspace-analytics/logs' + search
        el.router(target, el.getRoot())
      } catch (err) {
        window.location.replace('/workspace-analytics/logs')
      }
    },
    Notice: {
      tag: 'span',
      fontSize: 'Y',
      color: 'caption',
      text: '{{ workspace.redirect.openingLogs | polyglot }}'
    }
  }
}
